import { Injectable, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { EnvironmentService } from 'src/app/core/environment.service';

@Injectable({
  providedIn: 'root',
})
export class CanAccessRegisterFormGuard {
  private environmentService = inject(EnvironmentService);

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.environmentService.isWhiteLabelMyVetReco) {
      window.location.href = this.environmentService.getGlobalRedirectURI();
      return false;
    }
    return true;
  }
}
